<p-panel header="Encounters To Process" styleClass="mb-5">
    <div class="flex w-full">

        <p-table [value]="encountersToInvoice" [(selection)]="selectedEncounters" dataKey="id">
    
            <ng-template pTemplate="caption">
                <div class="flex w-full flex-row">
                        <div class="flex w-12 justify-content-end">
                            <p-button [disabled]="processing" icon="pi pi-refresh" label="Refresh Encounters" (onClick)="searchEncounters()">
                                <ng-template pTemplate="icon">
                                    <i class="pi pi-refresh mr-2" [ngClass]="searchingEncounters?'pi-spin':''" style="font-size: 1rem"></i>
                                </ng-template>
                            </p-button>
                        </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>Encounter Id</th>
                    <th>Service Date</th>
                    <th>Bill</th>
                    <th>Invoice</th>
                    <th>Gain</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-encounter let-rowIndex="rowIndex">
                <tr>
                    <td>
                        <p-tableCheckbox [disabled]="processing" [value]="encounter" />
                    </td>
                    <td>{{encounter.id}}</td>
                    <td>{{encounter.serviceDate | date : 'shortDate'}}</td>
                    <td>{{encounter.amountBilled | currency}}</td>
                    <td>{{encounter.amountToInvoice | currency}}</td>
                    <td>{{encounter.gain | currency}}</td>
                    <td>
                        <i *ngIf="processingStatus[encounter.id]" class="pi pi-spin pi-spinner"></i>
                        <i *ngIf="errorStatus[encounter.id]" class="pi pi-exclamation-triangle text-red-600" [pTooltip]="errorStatus[encounter.id].message"></i>

                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td colspan="7">
                        <div class="flex w-full justify-content-end">
                            <p-button [disabled]="selectedEncounters.length == 0 || processing" icon="pi pi-bolt" label="Process" (onClick)="processSelectedEncounters()"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    
</p-panel>

<p-panel header="Bills and Invoices">

    <div class="flex flex-column w-full h-full surface-100">
        <div class="flex flex-row w-full p-5 pb-0">
            <div class="flex w-3">
                <p-floatLabel>
                    <p-calendar id="searchAfter" [(ngModel)]="searchAfter"></p-calendar>
                    <label for="searchAfter">Issued After</label>
                </p-floatLabel>
            </div>
            <div class="flex w-3">
                <p-floatLabel>
                    <p-calendar id="searchBefore" [(ngModel)]="searchBefore"></p-calendar>
                    <label for="searchBefore">Issued Before</label>
                </p-floatLabel>
            </div>
            <div class="flex w-3">
                <p-checkbox [(ngModel)]="includeComplete" binary label="Include Complete?"></p-checkbox>
            </div>
            <div class="flex w-3">
                <p-button icon="pi pi-search" label="Search" (onClick)="searchFinancials()" [disabled]="processing"></p-button>

            </div>

        </div>

        <div class="flex flex-row w-full h-full surface-100">

            <div class="flex w-6 flex-column flex-auto surface-card m-5 p-2 border-round">
                <div class="flex m-2">
                    <p-table [value]="processedEncounters"
                    selectionMode="single" 
                    [(selection)]="selectedProcessedEncounter"
                    dataKey="id"
                    (onRowSelect)="processedEncounterSelected($event)" 
                    (onRowUnselect)="processedEncounterUnselected($event)">
                        <ng-template pTemplate="caption">
                            Encounters Already Processed
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Id</th>
                                <th>Date</th>
                                <th>Bill</th>
                                <th>Invoice</th>
                                <th>Gain</th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-encounter>
                            <tr [pSelectableRow]="encounter"
                            [pTooltip]="getExtraInfo(encounter)" tooltipPosition="right">
                                <td>{{encounter.id}}</td>
                                <td>{{encounter.serviceDate | date : 'shortDate'}}</td>
                                <td>{{encounter.amountBilled | currency}}</td>
                                <td>{{encounter.amountToInvoice | currency}}</td>
                                <td>{{encounter.gain | currency}}</td>
                                <td>
                                    <div class="flex gap-2">
                                        <p-button icon="pi pi-undo" text (onClick)="unProcessEncounter(encounter)" pTooltip="Un-Post">
                                            <ng-template pTemplate="icon">
                                                <i class="pi pi-undo" [ngClass]="unProcessingStatus[encounter.id]?'pi-spin':''" style="font-size: 1rem"></i>
                                            </ng-template>
                                        </p-button>
                                        <p-button icon="pi pi-file" text (onClick)="viewPayerBill(encounter)" pTooltip="View Invoice"></p-button>
                                        <p-splitButton appendTo="body" icon="pi pi-envelope" label="Email" (onClick)="packageEmailDialogVisible[encounter.id] = true; newDraftEmail(encounter)" [model]="packageOptions[encounter.id]">
                                        </p-splitButton>
                                        <p-dialog [(visible)]="packageEmailDialogVisible[encounter.id]" appendTo="body" #newEmailOp [style]="{width: '50vw', height:'75vh'}" styleClass="overflow-y-scroll">
                                            <app-email-composer [emailHandler]="processedEncounterHandlers[encounter.id]" [allowAttachments]=false *ngIf="draftEmail" [draftEmail]="draftEmail" (sendEmail)="sendEmailPackage($event,encounter)" (cancelEmail)="packageEmailDialogVisible[encounter.id] = false; cancelEmail();"></app-email-composer>
                                        </p-dialog>
                                    </div>

                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                
            </div>
        
            <div class="flex w-3 flex-column flex-auto surface-card m-5 p-2 border-round">
                
        
                <div class="flex m-2">
                    <p-table [value]="foundInvoices"
                    selectionMode="single" 
                    [(selection)]="selectedProcessedInvoice"
                    dataKey="id"
                    (onRowSelect)="processedInvoiceSelected($event)" 
                    (onRowUnselect)="processedInvoiceUnselected($event)" >

                        <ng-template pTemplate="caption">
                            Invoices
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Id</th>
                                <th>Amount</th>
                                <th>Due Date</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-invoice>
                            <tr [pSelectableRow]="invoice">
                                <td>{{invoice.id}}</td>
                                <td>{{invoice.amount | currency}}</td>
                                <td>{{invoice.invoiceDate | date : 'shortDate' }}</td>
                            </tr>
                        </ng-template>
            
                    </p-table>
                </div>

                
            </div>
            <div class="flex w-3 flex-column flex-auto surface-card m-5 p-2 border-round">
                <div class="flex m-2">

                    <p-table [value]="foundBills"
                    selectionMode="single" 
                    [(selection)]="selectedProcessedBills"
                    dataKey="id"
                    (onRowSelect)="processedBillSelected($event)" 
                    (onRowUnselect)="processedBillUnselected($event)" >
                        <ng-template pTemplate="caption">
                            Bills
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Id</th>
                                <th>Amount</th>
                                <th>Due Date</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-bill>
                            <tr [pSelectableRow]="bill">
                                <td>{{bill.id}}</td>
                                <td>{{bill.amount | currency}}</td>
                                <td>{{bill.billDate | date : 'shortDate' }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        
        </div>
        

    </div>
</p-panel>



